import React from 'react';
import FormFieldMapper from '../components/FormFieldMapper';

function UploadPDFs() {
  return (
    <div style={{ height: '100%' }}>
      <FormFieldMapper />
    </div>
  );
}

export default UploadPDFs;
